import React from "react";
import { useQuery } from "react-query";
import { getItemizedDetailsById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetItemizedByInvoiceDetailsId = (invoiceDetailsId) => {
  return useQuery(
    ["GetItemizedDetailsById", invoiceDetailsId],
    () => getItemizedDetailsById(invoiceDetailsId),
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetItemizedByInvoiceDetailsId;
